<div class="work-log-shell min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-6 -mx-2 sm:-mx-4">
  <!-- Header -->
  <div class="mb-8">
    <div class="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
      <div>
        <h1 class="text-3xl font-bold text-gray-900 mb-2">
          {{ 'WORK_LOG_TITLE' | translate }}
        </h1>
        <p class="text-gray-600 max-w-2xl">
          {{ 'WORK_LOG_SUBTITLE' | translate }}
        </p>
      </div>
      <div class="flex flex-wrap gap-3">
        <div class="bg-white rounded-xl px-4 py-3 shadow-sm border border-gray-200 min-w-[140px]">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center">
              <svg class="w-5 h-5 text-sky-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
            </div>
            <div>
              <p class="text-xs font-medium text-gray-500 uppercase tracking-wide">{{ 'TOTAL_ENTRIES' | translate }}</p>
              <p class="text-xl font-semibold text-gray-900">{{ dataSource.data.length }}</p>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-xl px-4 py-3 shadow-sm border border-gray-200 min-w-[140px]">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-violet-100 rounded-lg flex items-center justify-center">
              <svg class="w-5 h-5 text-violet-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <div>
              <p class="text-xs font-medium text-gray-500 uppercase tracking-wide">{{ 'WITH_ATTACHMENTS' | translate }}</p>
              <p class="text-xl font-semibold text-gray-900">{{ withAttachmentsCount }}</p>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-xl px-4 py-3 shadow-sm border border-gray-200 min-w-[140px]">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center">
              <svg class="w-5 h-5 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
              </svg>
            </div>
            <div>
              <p class="text-xs font-medium text-gray-500 uppercase tracking-wide">{{ 'FILTERED' | translate }}</p>
              <p class="text-xl font-semibold text-gray-900">{{ visibleCount }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Toolbar -->
  <div class="bg-white rounded-2xl shadow-lg border border-gray-200 p-6 mb-6">
    <div class="flex flex-col lg:flex-row gap-4 lg:items-center">
      <div class="flex-1 relative">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
        <input
          type="text"
          class="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-xl leading-5 bg-gray-50 focus:bg-white focus:border-sky-500 focus:ring-2 focus:ring-sky-200 focus:outline-none transition-all duration-200 text-gray-800"
          [placeholder]="'SEARCH_WORK_LOG_PLACEHOLDER' | translate"
          (input)="applyFilter($event)"
        />
      </div>
      <div class="flex flex-wrap gap-3">
        <button
          type="button"
          (click)="refresh()"
          [disabled]="loading"
          class="inline-flex items-center justify-center px-4 py-3 border border-gray-300 rounded-xl text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 disabled:opacity-50 transition-colors"
        >
          <svg class="w-4 h-4 mr-2 shrink-0" [class.animate-spin]="loading" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          {{ 'REFRESH' | translate }}
        </button>
        <button
          type="button"
          (click)="openAddWorkDialog()"
          class="inline-flex items-center justify-center px-6 py-3 border border-transparent text-sm font-semibold rounded-xl text-white bg-gradient-to-r from-sky-600 to-indigo-600 hover:from-sky-700 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 shadow-lg transition-all"
        >
          <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
          {{ 'ADD_WORK' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Table card -->
  <div class="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
    <div class="px-6 py-4 border-b border-gray-200 bg-gray-50 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
      <div>
        <h2 class="text-lg font-semibold text-gray-900">{{ 'WORK_LOG_OVERVIEW' | translate }}</h2>
        <p class="text-sm text-gray-600 mt-0.5">{{ 'WORK_LOG_OVERVIEW_DESC' | translate }}</p>
      </div>
    </div>

    <div *ngIf="loading" class="flex flex-col items-center justify-center py-16 text-gray-600">
      <mat-spinner diameter="40"></mat-spinner>
      <p class="mt-4 text-sm">{{ 'LOADING' | translate }}…</p>
    </div>

    <div *ngIf="!loading && dataSource.data.length === 0" class="empty-state py-16 px-6 text-center">
      <div class="w-16 h-16 mx-auto mb-4 rounded-2xl bg-sky-100 flex items-center justify-center">
        <svg class="w-8 h-8 text-sky-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      </div>
      <h3 class="text-lg font-semibold text-gray-900 mb-2">{{ 'NO_WORK_LOGS' | translate }}</h3>
      <p class="text-gray-600 max-w-md mx-auto mb-6">{{ 'NO_WORK_LOGS_HINT' | translate }}</p>
      <button
        type="button"
        (click)="openAddWorkDialog()"
        class="inline-flex items-center px-5 py-2.5 rounded-xl text-white bg-sky-600 hover:bg-sky-700 font-medium text-sm shadow-md transition-colors"
      >
        {{ 'ADD_WORK' | translate }}
      </button>
    </div>

    <div *ngIf="!loading && dataSource.data.length > 0" class="overflow-x-auto">
      <table mat-table [dataSource]="dataSource" matSort class="work-log-table w-full">
        <ng-container matColumnDef="srNo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="work-log-th">#</th>
          <td mat-cell *matCellDef="let element; let i = index" class="work-log-td text-gray-500 font-medium">
            {{ i + 1 + (paginator?.pageIndex || 0) * (paginator?.pageSize || 10) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="work-log-th">Title</th>
          <td mat-cell *matCellDef="let element" class="work-log-td">
            <span class="text-gray-900 font-semibold line-clamp-1">{{ element.title || '—' }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="work-log-th">{{ 'DESCRIPTION' | translate }}</th>
          <td mat-cell *matCellDef="let element" class="work-log-td">
            <span class="text-gray-700 line-clamp-2">{{ element.description }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="work-log-th">{{ 'WORK_LOG_DATE' | translate }}</th>
          <td mat-cell *matCellDef="let element" class="work-log-td">
            <span class="inline-flex items-center gap-1.5 text-gray-800">
              <svg class="w-4 h-4 text-sky-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              {{ element.dateFormatted }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="hours">
          <th mat-header-cell *matHeaderCellDef class="work-log-th">Hours</th>
          <td mat-cell *matCellDef="let element" class="work-log-td text-gray-800">{{ element.hoursWorked }}h</td>
        </ng-container>

        <ng-container matColumnDef="progress">
          <th mat-header-cell *matHeaderCellDef class="work-log-th">Progress</th>
          <td mat-cell *matCellDef="let element" class="work-log-td text-gray-800">{{ element.progressPercentage }}%</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef class="work-log-th">Status</th>
          <td mat-cell *matCellDef="let element" class="work-log-td">
            <span class="text-xs font-semibold uppercase tracking-wide px-2 py-1 rounded-lg bg-sky-50 text-sky-800">
              {{ element.status }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="work-log-th">{{ 'RECORDED_AT' | translate }}</th>
          <td mat-cell *matCellDef="let element" class="work-log-td text-sm text-gray-600">
            {{ element.createdAtFormatted }}
          </td>
        </ng-container>

        <ng-container matColumnDef="images">
          <th mat-header-cell *matHeaderCellDef class="work-log-th">{{ 'FILES' | translate }}</th>
          <td mat-cell *matCellDef="let element" class="work-log-td">
            <div class="flex flex-wrap gap-2 items-center">
              <button
                type="button"
                *ngFor="let img of element.imageList; let fi = index"
                class="thumb-btn group relative rounded-xl overflow-hidden border border-gray-200 shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-500"
                (click)="openImageDialog(img)"
                [matTooltip]="'VIEW_ATTACHMENT' | translate"
                matTooltipPosition="above"
              >
                <img [src]="img" alt="" class="w-16 h-16 object-cover block bg-gray-100" />
                <span class="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors"></span>
              </button>
              <span *ngIf="element.fileCount === 0" class="text-sm text-gray-400 italic">—</span>
              <span
                *ngIf="element.fileCount > 0"
                class="text-xs font-medium text-sky-700 bg-sky-50 px-2 py-1 rounded-lg"
              >
                {{ element.fileCount }}
              </span>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="work-log-header-row"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="work-log-row"></tr>
      </table>
    </div>

    <div *ngIf="!loading && dataSource.data.length > 0" class="border-t border-gray-100 px-2 py-1 bg-gray-50/80">
      <mat-paginator
        [length]="dataSource.data.length"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
        class="work-log-paginator"
      >
      </mat-paginator>
    </div>
  </div>
</div>
